import { Office, Opportunity } from '../types';

export type LeadProjectCreateIntent = 'proposal' | 'awarded';

export type ProposalTypeLockState = {
  lockToProposalType: true;
};

export type LeadProjectCreateState = {
  fromOpportunityId: string;
  intent: LeadProjectCreateIntent;
  name?: string;
  client_id?: number;
  office_id?: number;
  commercial_owner_id?: number;
  email?: string;
  year?: number;
  initial_budget?: number;
  nd_budget?: number;
  project_start_date?: string;
  project_planned_end_date?: string;
};

export function isLeadProjectCreateState(value: unknown): value is LeadProjectCreateState {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as LeadProjectCreateState;
  return Boolean(candidate.fromOpportunityId) && (candidate.intent === 'proposal' || candidate.intent === 'awarded');
}

export function isProposalTypeLockState(value: unknown): value is ProposalTypeLockState {
  return Boolean(
    value
    && typeof value === 'object'
    && (value as ProposalTypeLockState).lockToProposalType === true,
  );
}

export const STANDALONE_PROPOSAL_CREATE_STATE: ProposalTypeLockState = {
  lockToProposalType: true,
};

export function opportunityToCreateProjectState(
  opportunity: Opportunity,
  intent: LeadProjectCreateIntent,
): LeadProjectCreateState {
  const budget =
    intent === 'proposal'
      ? opportunity.proposal_amount
      : opportunity.final_value ?? opportunity.opportunity_value ?? opportunity.estimated_value;
  const startDate =
    intent === 'awarded'
      ? opportunity.closing_date || opportunity.expected_closing_date
      : opportunity.expected_closing_date || opportunity.proposal_date;
  const yearSource = startDate || opportunity.expected_closing_date;
  return {
    fromOpportunityId: opportunity.id,
    intent,
    name: opportunity.title,
    client_id: opportunity.client_id,
    office_id: opportunity.office_id,
    commercial_owner_id: opportunity.commercial_owner_id,
    email: opportunity.email,
    year: yearSource ? Number(String(yearSource).slice(0, 4)) : new Date().getFullYear(),
    initial_budget: budget,
    nd_budget: budget,
    project_start_date: startDate,
    project_planned_end_date: opportunity.expected_closing_date,
  };
}

export function officeCodeFromId(offices: Office[], officeId?: number): string | undefined {
  if (!officeId) return undefined;
  return offices.find((office) => office.id === officeId)?.code || undefined;
}
